import React, { useEffect, useRef, useState } from "react";
import Spinner from "../Spinner/Spinner";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "react-router-dom";
import classes from "./SpecificProduct.module.css";
import { SideBySideMagnifier } from "react-image-magnifiers";
import { capitalizeFirstLetter, stringToHTML } from "../../store/utility";
import CounterBtn from "../UI/Cart/CounterBtn";
import ReviewCard from "../UI/ReviewCard/ReviewCard";
import SimpleRating from "../UI/Rating/SimpleRating";
import "react-quill/dist/quill.snow.css";
import QuillViewer from "../UI/QuillEditor/QuillViewer";
import { string_to_slug as slug } from "../../store/utility";
const SpecificProduct = (props) => {
  const [productImgUrl, setProductImgUrl] = useState(null);
  const [variant, setVariant] = useState(null);
  const [attributes, setAttributes] = useState(null);
  const [immutableAttributes, setImmutableAttributes] = useState(null); //For Referencing all atrributes initially computed
  const [primaryAttribute, setPrimaryAttribute] = useState(null);
  const [oneTimeSelectChange, setSelectChange] = useState(false);
  const [primaryValue, setPrimaryValue] = useState(false);
  useEffect(() => {
    const { productName, productId } = props.match.params;
    props
      .onFetchSingleProduct(productName, productId)
      .then((data) => {
        if (data.variable) {
          setVariant(data.variants[0]);
          setProductAttributes(data);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    if (immutableAttributes) {
      // console.log("Resetting Variant")
      resetVariant();
    }
  }, [attributes]);

  useEffect(() => {
    if (primaryValue) {
      handlePrimarySelectChange(null, primaryAttribute, immutableAttributes);
    }
  }, [primaryValue]);
  const resetVariant = () => {
    //by attribute name

    let variants = props.singleProduct.variants;
    let attrKeys = Object.keys(immutableAttributes);
    attrKeys.map((attrKey, i) => {
      let filter = document.getElementById(attrKey).value;
      variants = variants.filter(
        (varObj) => varObj.attributes[attrKey].name == filter
      );
    });
    //    console.log(variants)
    if (variants.length) {
      let variant = variants[0];
      setVariant(variant);

      if (productImgUrl && !variant.previewImages.includes(productImgUrl)) {
        let thumbnails = Array.from(
          document.getElementById("thumbnail").childNodes
        );
        thumbnails.map((thumb) => {
          thumb.style.backgroundColor = "white";
        });
        setProductImgUrl(variant.previewImages[0]);
      }
    }
  };
  const arrowLeft = () => {
    let thumbnail = document.getElementById("thumbnail");
    thumbnail.scrollBy({
      left: -50,
      behavior: "smooth",
    });
  };

  const arrowRight = () => {
    let thumbnail = document.getElementById("thumbnail");
    thumbnail.scrollBy({
      left: 50,
      behavior: "smooth",
    });
  };
  const resetSelection = (id) => {
    let thumbnails = Array.from(
      document.getElementById("thumbnail").childNodes
    );

    thumbnails.map((thumb) => {
      thumb.style.backgroundColor = "white";
    });
    let selectedThumb = document.getElementById(id);
    selectedThumb.style.backgroundColor = "#FF8D1E";
    let selectedImage = selectedThumb.firstElementChild.src;
    setProductImgUrl(selectedImage);
  };
  const handleThumbnailClicked = (id) => {
    resetSelection(id);
  };

  const setup = (required) => {
    switch (required) {
      case "productImgUrl":
        if (productImgUrl) {
          return productImgUrl;
        } else {
          if (product.variable) {
            if (variant) {
              return variant.previewImages[0];
            } else {
              return product.variants[0].previewImages[0];
            }
          } else {
            //return product.productImgUrl;
            return product.previewImages[0];
          }
        }
      case "previewImages":
        if (product.variable) {
          if (variant) {
            return variant.previewImages;
          } else {
            return product.variants[0].previewImages;
          }
        } else {
          return product.previewImages;
        }
      case "id":
        if (variant) {
          return variant.variantId;
        } else {
          return product.id;
        }
      case "stock":
        if (variant) {
          let variableStock = product.variableStock;
          if (variableStock) {
            let variantId = variant.variantId;
            return variableStock[variantId] ? variableStock[variantId] : 0;
          } else {
            return 0;
          }
        } else {
          return product.stock;
        }
      case "brand":
        return product["brand"];
      case "brandId":
        return product["brandId"];
      default:
        return product.variable
          ? variant
            ? variant[required]
            : product.variants[0][required]
          : product[required];
    }
  };

  const setProductAttributes = (product) => {
    let result = {};
    if (product.variable) {
      let variants = product.variants;
      variants.map((varObj) => {
        let attributes = varObj["attributes"];
        for (let attrKey in attributes) {
          if (result[attrKey]) {
            let attrVal = result[attrKey];
            attrVal.push({
              ...attributes[attrKey],
              variantId: varObj.variantId,
            });
            result[attrKey] = attrVal;
          } else {
            result[attrKey] = [
              { ...attributes[attrKey], variantId: varObj.variantId },
            ];
          }
        }
      });

      let primaryKey = Object.keys(result)[0];
      setAttributes(result);
      setImmutableAttributes(result);
      setPrimaryAttribute(primaryKey);

      //handlePrimarySelectChange(null,primaryKey,attributes)
    }

    //    console.log(attributes)
  };

  const handlePrimarySelectChange = (
    e,
    hardcodedPrimaryKey,
    _immutableAttr
  ) => {
    //It only filters the select options of secondary attributes based on primaryKey
    let value = e
      ? e.target.value
      : document.getElementById(hardcodedPrimaryKey).value;
    let primaryKey = primaryAttribute ? primaryAttribute : hardcodedPrimaryKey;

    let attrs = immutableAttributes
      ? { ...immutableAttributes }
      : { ..._immutableAttr };

    let matchattrs = props.singleProduct.variants.filter(
      (vObj) => vObj.attributes[primaryKey]["name"] === value
    ); // by attribute name
    //    console.log(matchattrs)
    if (matchattrs.length) {
      let acceptedVariantIds = [];
      matchattrs.map((vObj) => acceptedVariantIds.push(vObj.variantId));
      Object.keys(attrs).map((attrKey) => {
        if (attrKey != primaryAttribute) {
          let remAttr = attrs[attrKey].filter((attrObj) =>
            acceptedVariantIds.includes(attrObj.variantId)
          ); //ex: size
          attrs[attrKey] = remAttr;
        }
      });
    }
    // console.log(attrs)

    setAttributes(attrs);
  };
  const handleSecondarySelectChange = (
    e,
    hardcodedPrimaryKey,
    _immutableAttr
  ) => {
    // resetVariant()

    let value = document.getElementById(hardcodedPrimaryKey).value;
    let primaryKey = hardcodedPrimaryKey;

    let attrs = _immutableAttr;

    let matchattrs = props.singleProduct.variants.filter(
      (vObj) =>
        vObj.attributes[primaryKey]["name"] === value &&
        vObj.attributes[primaryAttribute]["name"] == primaryValue
    ); // by attribute name

    if (matchattrs.length) {
      let acceptedVariantIds = [];
      matchattrs.map((vObj) => acceptedVariantIds.push(vObj.variantId));
      Object.keys(attrs).map((attrKey) => {
        if (attrKey != primaryAttribute) {
          //here conditon means no filtering w.r.t the respective attribute in the immutableAttr
          if (attrKey == hardcodedPrimaryKey) {
            let ids = [];
            let x = props.singleProduct.variants.filter(
              (vObj) =>
                vObj.attributes[primaryAttribute]["name"] == primaryValue
            );
            x.map((vObj) => ids.push(vObj.variantId));
            let remx = attrs[attrKey].filter((attrObj) =>
              ids.includes(attrObj.variantId)
            );
            attrs[attrKey] = remx;
          } else {
            let remAttr = attrs[attrKey].filter((attrObj) =>
              acceptedVariantIds.includes(attrObj.variantId)
            ); //ex: size
            attrs[attrKey] = remAttr;
          }
        }
      });
    }
    // console.log(attrs)
    setAttributes(attrs);
  };

  const handleAddToCart = () => {
    if (!props.userId) {
      return alert("Please Login");
    }
    let cartProduct = null;
    if (variant) {
      variant.id = product.id;
      cartProduct = variant;
    } else {
      cartProduct = product;
    }
    props.onAddToCart(props.userId, cartProduct);
  };
  const handleChange = (e, index, attrKey) => {
    if (index == 0) {
      setPrimaryValue(e.target.value);
    } else {
      // handlePrimarySelectChange(null,attrKey,immutableAttributes)
      //   let vari =   props.singleProduct.variants.filter(vObj=>vObj.attributes[primaryAttribute]["name"]==primaryValue&&

      //     vObj.attributes[attrKey]["name"]==getSecondaryValue(attrKey)
      //     )
      //     setVariant(vari[0])
      // handleSecondarySelectChange(null,attrKey,immutableAttributes)
      resetVariant();
    }
  };
  const getSecondaryValue = (id) => {
    if (document.getElementById(id)) {
      return document.getElementById(id).value;
    } else {
      return false;
    }
  };

  const formatExpiry = (expiryTimestamp) => {
    let date = new Date(expiryTimestamp);
    let month = date.toLocaleString("default", { month: "short" });
    let year = date.getFullYear();
    return `${month}-${year}`;
  };
  if (props.loading) {
    return <Spinner />;
  }
  let product = props.singleProduct;
  // console.log(product)
  if (!product) {
    return <h6>Product does not exists</h6>;
  }
  // col-lg-4 col-sm-12 col-md-12 col-12
  if (
    document.getElementById(primaryAttribute) &&
    !oneTimeSelectChange &&
    attributes
  ) {
    setSelectChange(true);
    // let primaryValue = document.getElementById(primaryAttribute).value;
    //setPrimaryValue(primaryValue)
    handlePrimarySelectChange(null, primaryAttribute, immutableAttributes);
  }

  return (
    <div className="container pt-5">
      <div
        className={`${classes.MagnifierContainer} col-sm-12 col-md-12 col-12`}
      >
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div className={classes.InputPosition}>
            <div>
              <SideBySideMagnifier
                imageSrc={setup("productImgUrl")}
                alwaysInPlace={false}
                overlayOpacity={0.6}
                // switchSides={false}
                // zoomPosition="left"
                // inPlaceMinBreakpoint={641}
                fillAvailableSpace={false}
                // fillAlignTop={false}
                // fillGapTop={100}
                // fillGapRight={100}
                // fillGapBottom={100}
                // fillGapLeft={100}
                zoomContainerBorder="1px solid #ccc"
                zoomContainerBoxShadow="0 4px 8px rgba(0,0,0,.5)"
              />
            </div>

            <div className={classes.thumbnailContainer}>
              <i class="fa fa-angle-left" onClick={arrowLeft}></i>

              <div className={classes.thumbnail} id="thumbnail">
                {setup("previewImages").map((url, index) => (
                  <div
                    className={classes.thumbnailImg}
                    id={`thumbnail${index}`}
                    onClick={() => handleThumbnailClicked(`thumbnail${index}`)}
                  >
                    <img src={url} />
                  </div>
                ))}
              </div>
              <i class="fa fa-angle-right" onClick={arrowRight}></i>
            </div>
          </div>

          <div
            className="flex-wrap"
            style={{ flex: 1, justifyContent: "center" }}
          >
            <form>
              <div
                className={`form-row justify-content-around ${classes.BrandAndReview}`}
              >
                <div className="col-xs-12 ">
                  <p
                    className="form-control-plaintext d-inline-flex align-items-baseline"
                    style={{ display: "-webkit-box", lineHeight: "normal" }}
                  >
                    <h6>
                      <b>Brand:</b>&nbsp;
                    </h6>

                    <label style={{ fontSize: "13px" }}>
                      <a
                        href={`/brand/${slug(setup("brand"))}/${setup(
                          "brandId"
                        )}/${props.categoryType}`}
                      >
                        {" "}
                        {setup("brand")}
                      </a>
                    </label>
                  </p>
                </div>
                <div className="col-xs-12">
                  <div style={{ display: "flex" }}>
                    {setup("rating") && (
                      <SimpleRating
                        rating={4}
                        key={Math.random() * 10000}
                        readOnly={"readOnly"}
                        // onPostRating={()=>this.props.onPostReview(order.receipt,order.rating,null)}
                      />
                    )}
                    {setup("reviewCount") && (
                      <label>
                        ({setup("reviewCount")}{" "}
                        {setup("reviewCount") > 1 ? "reviews" : "review"})
                      </label>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-group pl-3 text-center">
                <label className="form-control-plaintext">
                  <p align="justify" className="pl-2 text-center">
                    <h4>
                      <b>{setup("productTitle")}</b>
                    </h4>
                  </p>
                </label>
              </div>

              <div
                className="form-row justify-content-center"
                style={
                  {
                    // marginTop:
                    //   window.innerWidth >= 440 && window.innerWidth <= 640
                    //     ? "6rem"
                    //     : "0rem",
                  }
                }
              >
                <div className="col col-md-2 my-1">
                  <label
                    type="text"
                    className="form-control-plaintext text-center"
                    style={{ textDecoration: "line-through" }}
                    placeholder="First name"
                  >
                    Rs {setup("regularPrice")}
                  </label>
                </div>
                <div className="col col-md-2 my-1">
                  <label
                    type="text"
                    className="form-control-plaintext text-center"
                    placeholder="Last name"
                  >
                    Rs. {setup("salePrice")}
                  </label>
                </div>
                <div className="col col-md-2 my-1">
                  {/* <label type="text" className="form-control-plaintext text-center" placeholder="Last name">{Math.round((1 - (setup("salePrice")/setup("regularPrice")))*100)}% Off</label> */}
                  <span className="badge  badge-danger">
                    {Math.round(
                      (1 - setup("salePrice") / setup("regularPrice")) * 100
                    )}
                    % Off
                  </span>
                </div>
              </div>

              <div className="form-row justify-content-around">
                <div className="col-xs-12  my-1">
                  <p
                    className="form-control-plaintext"
                    style={{ display: "-webkit-box", lineHeight: "normal" }}
                  >
                    <h6>
                      <b>Availability:</b>&nbsp;
                    </h6>
                    {setup("stock") ? (
                      <label>In Stock</label>
                    ) : (
                      <label className="text-danger text-center ">
                        Out Of Stock
                      </label>
                    )}
                  </p>
                </div>
                {setup("expiry") && (
                  <div className="col-xs-12  my-1">
                    <p
                      className="form-control-plaintext"
                      style={{ display: "-webkit-box", lineHeight: "normal" }}
                    >
                      <h6>
                        <b>Best before:</b>&nbsp;
                      </h6>
                      <label>{formatExpiry(setup("expiry"))}</label>
                    </p>
                  </div>
                )}
              </div>

              {product.variable && attributes && (
                <div className="form-row justify-content-around">
                  {Object.keys(attributes).map((attrKey, index) => (
                    <div
                      className="form-group col-5 col-md-5"
                      key={index + Math.random() * 1000}
                    >
                      <label for={attrKey}>
                        {capitalizeFirstLetter(
                          product.variants[product.variants.length - 1]
                            .attributes[attrKey].attribute
                        )}
                      </label>
                      {
                        <select
                          id={attrKey}
                          className="form-control"
                          onChange={(e) => handleChange(e, index, attrKey)}
                          value={
                            index == 0
                              ? primaryValue
                              : getSecondaryValue(attrKey)
                          }
                        >
                          {
                            //index==0?// by attribute name
                            attributes[attrKey]
                              .filter(
                                (v, i, a) =>
                                  a.findIndex((t) => t.name == v.name) === i
                              )
                              .map((attr, i) => (
                                <option
                                  selected={i == 0 ? true : false}
                                  value={attr.name}
                                >
                                  {attr.name}
                                </option>
                              ))
                          }
                        </select>
                      }
                    </div>
                  ))}
                </div>
              )}

              {setup("stock") ? (
                <div
                  className="form-row justify-content-around mt-2"
                  style={{ alignItems: "center" }}
                >
                  <CounterBtn stock={setup("stock")} productId={setup("id")} />

                  <div className="form-group col-5 col-md-3 text-center">
                    <button
                      className="btn btn-outline-success"
                      type="button"
                      style={{ fontWeight: "bold" }}
                      onClick={handleAddToCart}
                      disabled={props.cartLoading}
                    >
                      <i class="fa fa-shopping-cart" aria-hidden="true">
                        {" "}
                      </i>
                      {props.cartLoading ? "Adding To Cart" : "Add to Cart"}
                    </button>
                  </div>
                </div>
              ) : // <div className="text-danger text-center pt-3">
              //   <h5>Out Of Stock</h5>
              // </div>
              null}

              {setup("keyFeatures") && (
                <div className="form-row align-items-center justify-content-center">
                  <QuillViewer value={setup("keyFeatures")} />
                </div>
              )}

              <div className="pt-5">
                <div className="container">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                      <a
                        className={`nav-link active ${classes.TabLink}`}
                        id="description-tab"
                        data-toggle="tab"
                        href="#description"
                        role="tab"
                        aria-controls="description"
                        aria-selected="true"
                      >
                        Description
                      </a>
                    </li>

                    <li class="nav-item">
                      <a
                        className={`nav-link  ${classes.TabLink}`}
                        id="additionalInfo-tab"
                        data-toggle="tab"
                        href="#additionalInfo"
                        role="tab"
                        aria-controls="additionalInfo"
                        aria-selected="false"
                      >
                        Additional Information
                      </a>
                    </li>

                    <li
                      className="nav-item"
                      onClick={() =>
                        props.onFetchReviews(product.id, product.variantId)
                      }
                    >
                      <a
                        className={`nav-link  ${classes.TabLink}`}
                        id="reviews-tab"
                        data-toggle="tab"
                        href="#reviews"
                        role="tab"
                        aria-controls="reviews"
                        aria-selected="false"
                      >
                        Reviews
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active mt-2"
                      id="description"
                      role="tabpanel"
                      aria-labelledby="description-tab"
                    >
                      <div>
                        <QuillViewer value={setup("productDesc")} />
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="reviews"
                      role="tabpanel"
                      aria-labelledby="reviews-tab"
                      style={{
                        position: "relative",
                        left: "4%",
                        maxHeight: "70vh",
                        overflowY: "auto",
                      }}
                    >
                      {props.reviews.map((review) => (
                        <React.Fragment>
                          <ReviewCard review={review} />
                        </React.Fragment>
                      ))}
                    </div>
                    <div
                      class="tab-pane fade"
                      id="additionalInfo"
                      role="tabpanel"
                      aria-labelledby="additionalInfo-tab"
                    >
                      {setup("additionalInfo") && (
                        <table className="table">
                          <tbody>
                            {Object.values(setup("additionalInfo")).map(
                              (row) => (
                                <tr>
                                  <th scope="row">{row.key}</th>
                                  <td>{row.value}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    singleProduct: state.homeProducts.singleProduct,
    loading: state.homeProducts.loading,
    userId: state.auth.userId,
    cartLoading: state.cart.loading,
    reviews: state.review.reviews,
    categoryType: state.categoryProducts.categoryType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchSingleProduct: (name, id) =>
      dispatch(actions.fetchSingleProduct(name, id)),
    onAddToCart: (userId, product) =>
      dispatch(actions.addProductToCart(userId, product)),
    onFetchReviews: (productId, variantId) =>
      dispatch(actions.fetchReviews(productId, variantId)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SpecificProduct)
);
